import axios from "axios"

class Search {
  // 1. describe and create/initiate our object
  //http://localhost/present/wp-json/present/v1/search?term='aster'
  constructor() {
    this.addSearchHTML();
    this.resultsDiv = document.querySelector("#search-overlay__results")
    this.openButton = document.querySelectorAll(".js-search-trigger")
    this.closeButton = document.querySelector(".search-overlay__close")
    this.searchOverlay = document.querySelector(".search-overlay")
    this.searchField = document.querySelector("#search-term")
    this.isOverlayOpen = false
    this.isSpinnerVisible = false
    this.previousValue
    this.typingTimer
    this.events()
  }

  // 2. events
  events() {
    this.openButton.forEach(el => {
      el.addEventListener("click", e => {
        e.preventDefault()
        this.openOverlay()
      })
    })

    this.closeButton.addEventListener("click", () => this.closeOverlay())
    document.addEventListener("keydown", e => this.keyPressDispatcher(e))
    this.searchField.addEventListener("keyup", () => this.typingLogic())
  }

  // 3. methods (function, action...)
  typingLogic() {  
    if (this.searchField.value != this.previousValue) {
      clearTimeout(this.typingTimer)

      if (this.searchField.value) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.innerHTML = '<div class="spinner-loader"></div>'
          this.isSpinnerVisible = true
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750)
      } else {
        this.resultsDiv.innerHTML = ""
        this.isSpinnerVisible = false
      }
    }

    this.previousValue = this.searchField.value
  }

  async getResults() {
    try {
      const response = await axios.get(presentData.root_url + '/wp-json/present/v1/search?term="' + this.searchField.value + '"')
      const results = response.data
      //console.log(results)
      this.resultsDiv.innerHTML = `
        <div class="search-row">

        <div class="one-third">
            <h2 class="search-overlay__section-title">Plantes</h2>
            ${results.plantes.length ? '<ul class="link-list min-list">' : `<p>0 trouvé. <a href="${presentData.root_url}/plantes">Voir toutes les plantes</a></p>`}
            ${results.plantes.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join("")}
            ${results.plantes.length ? "</ul>" : ""}

            <h2 class="search-overlay__section-title">Familles</h2>
            ${results.familles.length ? '<ul class="link-list min-list">' : `<p>0 trouvé. <a href="${presentData.root_url}/familles">Voir toutes les familles</a></p>`}
            ${results.familles.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join("")}
            ${results.familles.length ? "</ul>" : ""}

        </div>

        <div class="one-third">
        
            <h2 class="search-overlay__section-title">Partages</h2>
            ${results.partages.length ? '<ul class="link-list min-list">' : `<p>0 trouvé. <a href="${presentData.root_url}/partages">Voir tous les partages</a></p>`}
            ${results.partages.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join("")}
            ${results.partages.length ? "</ul>" : ""}

            <h2 class="search-overlay__section-title">HE</h2>
            ${results.hes.length ? '<ul class="link-list min-list">' : `<p>0 trouvé. <a href="${presentData.root_url}/hes">Voir toutes les HE</a></p>`}
            ${results.hes.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join("")}
            ${results.hes.length ? "</ul>" : ""}

            <h2 class="search-overlay__section-title">HA</h2>
            ${results.has.length ? '<ul class="link-list min-list">' : `<p>0 trouvé. <a href="${presentData.root_url}/has">Voir toutes les HA</a></p>`}
            ${results.has.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join("")}
            ${results.has.length ? "</ul>" : ""}
    

        

        </div>
        <div class="one-third">
            <h2 class="search-overlay__section-title">Système de santé</h2>
            ${results.santes.length ? '<ul class="link-list min-list">' : `<p>0 trouvé. <a href="${presentData.root_url}/santes">Voir toutes les systèmes de santé</a></p>`}
            ${results.santes.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join("")}
            ${results.santes.length ? "</ul>" : ""}
          </div>
          <div class="one-third">
            <h2 class="search-overlay__section-title">Familles Bio Chimiques</h2>
            ${results.fbiochims.length ? '<ul class="link-list min-list">' : `<p>0 trouvé. <a href="${presentData.root_url}/fbiochims">Voir toutes les familles biochimiques</a></p>`}
            ${results.fbiochims.map(item => `<li><a href="${item.permalink}">${item.title}</a></li>`).join("")}
            ${results.fbiochims.length ? "</ul>" : ""}

          </div>
        </div>
      `
      this.isSpinnerVisible = false
    } catch (e) {
      console.log(e)
    }
  }

  

  keyPressDispatcher(e) {
    //console.log (e.keyCode);console.log (e.key);
    if (e.ctrlKey && e.key === "y" && !this.isOverlayOpen && document.activeElement.tagName != "INPUT" && document.activeElement.tagName != "TEXTAREA") {
      this.openOverlay()
    }

    if (e.keyCode == 27 && this.isOverlayOpen) {
      this.closeOverlay()
    }
  }

  openOverlay() {
    this.searchOverlay.classList.add("search-overlay--active")
    document.body.classList.add("body-no-scroll")
    this.searchField.value = ""
    setTimeout(() => this.searchField.focus(), 301)
    //console.log("our open method just ran!")
    this.isOverlayOpen = true
    return false
    //ce return empeche le comportement de la balise a qui a été cliquée et ainsi utiliser le javascript pour la recherche plutot
    //que le search classique wp
  }

  closeOverlay() {
    this.searchOverlay.classList.remove("search-overlay--active")
    document.body.classList.remove("body-no-scroll")
    //console.log("our close method just ran!")
    this.isOverlayOpen = false
  }

  addSearchHTML() {
    document.body.insertAdjacentHTML(
      "beforeend",
      `
      <div class="search-overlay">
        <div class="search-overlay__top">
          <div class="container">
            <i class="fa fa-search search-overlay__icon" aria-hidden="true"></i>
            <input type="text" class="search-term" placeholder="Que cherchez vous?" id="search-term">
            <i class="fa fa-window-close search-overlay__close" aria-hidden="true"></i>
          </div>
        </div>
        
        <div class="search-main-container">
          <div id="search-overlay__results"></div>
        </div>

      </div>
    `
    )
  }
}

export default Search
